import React, { useMemo, useState } from "react";
import { Image, Modal } from "antd";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import { parseCsBroadcastContent, truncateCsBroadcastBody } from "./csBroadcastMessage";

export const CsBroadcastMessageCard: React.FC<{ content: string }> = ({ content }) => {
  const payload = useMemo(() => parseCsBroadcastContent(content), [content]);
  const [open, setOpen] = useState(false);

  if (!payload) {
    return <span>[群发通知]</span>;
  }

  const imageUrl = payload.imageUrl ? resolveAppMediaUrl(payload.imageUrl) ?? payload.imageUrl : "";
  const previewBody = truncateCsBroadcastBody(payload.body);

  return (
    <>
      <button type="button" className="lf-cs-broadcast-card" onClick={() => setOpen(true)}>
        {imageUrl ? <img src={imageUrl} alt="" className="lf-cs-broadcast-card-image" /> : null}
        <div className="lf-cs-broadcast-card-main">
          <div className="lf-cs-broadcast-card-title">{payload.title}</div>
          <div className="lf-cs-broadcast-card-body">{previewBody}</div>
        </div>
      </button>
      <Modal
        title="通知详情"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        destroyOnClose
        width={520}
      >
        <div className="lf-cs-broadcast-detail">
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt=""
              className="lf-cs-broadcast-detail-image"
              preview={{ mask: false, destroyOnHidden: true }}
            />
          ) : null}
          <div className="lf-cs-broadcast-detail-title">{payload.title}</div>
          <div className="lf-cs-broadcast-detail-body">{payload.body}</div>
        </div>
      </Modal>
    </>
  );
};

export default CsBroadcastMessageCard;
